import * as z from 'zod';

import { funcionarioSchema } from './functionarysSchema';

export const schema = z.object({
  codEmpresa: z.number(),
  codVendedor: z.number(),
  funcionario: z.optional(funcionarioSchema),
  dtInicioVigencia: z.string(),
});

export type Schema = z.infer<typeof schema>;
